export const
    ADD_NOTIFICATION="ADD_NOTIFICATION",
    CLEAR_NOTIFICATION="CLEAR_NOTIFICATION";


// WEBPACK FOOTER //
// ./src/types/Notification.js